import React from 'react';
import { ApIcon } from '@alixpartners/ui-components';
import {
	ProgressBarSection,
	ProgressBarTextWrapper,
	IconWrapper,
} from './styles';

const DownloadProgressbar = props => (
	<ProgressBarSection error={props.error}>
		<ProgressBarTextWrapper>
			{!props.error
				? props.successMessage
				: props.failMessage || 'Error downloading file'}
		</ProgressBarTextWrapper>
		<IconWrapper onClick={props.onClose}>
			<ApIcon iconName="baseline_close" iconSize="24px" iconColor="#cde7c7" />
		</IconWrapper>
	</ProgressBarSection>
);

export default DownloadProgressbar;
